import { jsx as _jsx } from "react/jsx-runtime";
import { lazy } from 'react';
var MandantDashBoard = lazy(function () { return import("@pages/common/dashboard/MandantDashBoard"); });
export var mandantRoutes = [
    {
        path: "dashboard",
        element: _jsx(MandantDashBoard, {}),
    }
];
